/**
 * Labstep
 */

import type { ValueGetterParams } from 'ag-grid-community';
import ResourceItemFilterResourceLocation from 'labstep-web/components/ResourceItem/Filter/ResourceLocation';
import { ICONS } from 'labstep-web/constants/icons';
import { DataGridPlaceholder } from 'labstep-web/core/DataGrid/Placeholder';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import {
  getEditable,
  setValue,
} from 'labstep-web/core/DataGrid/utils';
import type { GridIndexContextMenuFilterProps } from 'labstep-web/grid/Index/components/ContextMenu/types';
import type { Entity } from 'labstep-web/models/entity.model';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import { getResourceLocationModal } from './utils';

/**
 * Column definition for resource location
 * @returns Column definition
 */
const colDefResourceLocation = {
  colId: 'resource_location',
  headerName: ResourceLocation.getHumanReadableEntityName(
    false,
    true,
  ),
  headerComponentParams: {
    icon: ICONS.resource_location.primary,
    filter: (props: GridIndexContextMenuFilterProps) => (
      <ResourceItemFilterResourceLocation {...props} />
    ),
  },
  cellRenderer: (
    params: CellRendererParams<Entity>,
  ): React.ReactElement =>
    params.data?.resource_location ? (
      getResourceLocationModal(params, false)
    ) : (
      <DataGridPlaceholder
        params={params}
        children={`Specify ${ResourceLocation.getHumanReadableEntityName()}`}
        editable={getEditable()}
        placeholder={`No ${ResourceLocation.getHumanReadableEntityName()}`}
      />
    ),
  cellStyle: { display: 'flex' },
  cellEditor: (params: CellEditorParams<Entity>) =>
    getResourceLocationModal(params as any, true),
  cellEditorPopup: true,
  editable: getEditable(),
  valueGetter: (params: ValueGetterParams): number | null =>
    params.data?.resource_location?.guid || null,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.resource_location?.location_path || '',
  valueSetter: (params: any): boolean =>
    setValue('resource_location_guid', params.newValue, {
      entityName: params.data.entityName,
      id: params.data.idAttr,
    }),
};

export default colDefResourceLocation;
